import React from "react";

const Inventory = () => {
    return <div>This is inventory</div>;
};

export default Inventory;
